var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningcopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0027 7.81934V11.6388",
    stroke: "#303238",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0068 13.9307H9.99998H10.0068Z",
    fill: "#303238"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0068 13.9307H9.99998",
    stroke: "#303238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.64829 15.4419L9.15869 4.49553C9.54682 3.84294 10.492 3.84396 10.8787 4.49738L17.3572 15.4438C17.7518 16.1104 17.2713 16.9531 16.4967 16.9531H3.50776C2.7322 16.9531 2.25184 16.1085 2.64829 15.4419Z",
    stroke: "#303238",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningcopy);
export default __webpack_public_path__ + "static/media/Warning copy.e468f3af18d3bce198c20134d8246b3e.svg";
export { ForwardRef as ReactComponent };